<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="订单编号">
        <Input v-model="formValidate.orderNo" disabled></Input>
      </FormItem>
      <FormItem label="缸号" prop="batchNo">
        <Input v-model="formValidate.batchNo" placeholder="请输入缸号"></Input>
      </FormItem>
      <FormItem label="客户订单号" prop="customerOrder">
        <Input v-model="formValidate.customerOrder" placeholder="请输入客户订单号"></Input>
      </FormItem>
      <FormItem label="布匹颜色" prop="clothColor"
        >
        <Input
          v-model="formValidate.clothColor"
          placeholder="请输入布匹颜色"
        ></Input>
      </FormItem>
      <FormItem label="品名" prop="clothType"
        >
        <Input
          v-model="formValidate.clothType"
          placeholder="请输入品名"
        ></Input>
      </FormItem>
      <FormItem label="匹数" prop="pieceCount"
        >
        <Input
          :disabled="isEdit"
          v-model="formValidate.pieceCount"
          placeholder="请输入匹数"
        ></Input>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],
      isEdit: false,

      formValidate: {
        id: '',
        orderId: '',
        orderNo: '',
        batchNo: '',
        clothColor: '',
        clothType: '',
        pieceCount: '',
        customerOrder: ''
      },
      ruleValidate: {
        batchNo: [
          {
            required: true,
            message: '缸号必须填写',
            trigger: 'blur'
          }
        ],
        clothColor: [
          {
            required: true,
            message: '布匹颜色必须填写',
            trigger: 'blur'
          }
        ],
        clothType: [
          {
            required: true,
            message: '布匹类型必须填写',
            trigger: 'blur'
          }
        ],
        pieceCount: [
          {
            required: true,
            message: '匹数不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            pattern: /^\d+$/,
            message: '请输入数字',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setIsEdit (flag) {
      this.isEdit = flag
    },
    setOrderData (order) {
      this.formValidate.orderId = order.id
      this.formValidate.orderNo = order.no
    },
    setEditData (data) {
      // id: "",
      // orderId: "",
      // orderNo: "",
      // batchNo: "",
      // clothColor: "",
      // clothType: "",
      // pieceCount: "",
      this.formValidate.id = data.id
      this.formValidate.orderId = data.order_id
      this.formValidate.orderNo = data.orderNo
      this.formValidate.batchNo = data.batch_no
      this.formValidate.clothColor = data.cloth_color
      this.formValidate.clothType = data.cloth_type
      this.formValidate.pieceCount = data.piece_count.toString()
      this.formValidate.customerOrder = data.customer_order
    },

    handleChange (newTargetKeys) {
      this.formValidate.permissions = newTargetKeys
    },
    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
